// Utility to get label for suggestions in all widgets
// Utility to get label for suggestions in all widgets, dynamic and robust
export function getLabel(item: any, fields: string[]): string {
  if (!item) return ''
  for (const field of fields) {
    let value = item
    for (const key of field.split('.')) {
      if (value && typeof value === 'object' && key in value) {
        value = value[key]
      } else {
        value = undefined
        break
      }
    }
    if (typeof value === 'string' && value.trim()) return value
    if (typeof value === 'number') return String(value)
  }
  return ''
}

// Angular-equivalent for RepoWidget
export function getRepoTitle(collectorItem: any): string {
  if (!collectorItem) return ''
  return typeof collectorItem === 'string' ? collectorItem : collectorItem?.options?.url || ''
}

// Angular-equivalent for QAMetricsWidget
export function getAdoBoardName(collectorItem: any): string {
  if (!collectorItem) return ''
  if (collectorItem.description === 'qaCollector') {
    return collectorItem?.options?.boards?.[0]?.teamName || ''
  } else {
    return collectorItem?.options?.teamName || collectorItem?.name || ''
  }
}

// Angular-equivalent for BuildWidget
export function getBuildPipelineName(collectorItem: any): string {
  if (!collectorItem) return ''
  if (collectorItem.description === 'qaCollector') {
    return collectorItem?.options?.pipelines?.[0]?.jobName || ''
  } else {
    return collectorItem?.options?.jobName || ''
  }
}

export const getBuildTitle = (collectorItem: any) => {
  if (!collectorItem) return ''
  const description = collectorItem.description as string
  return description
}
